import { clsx } from 'clsx'
import Image from 'next/image'
import Link from 'next/link'

import Nickname from '@/components/nickname'
import Avatar from '@/components/ui/avatar'
import { formatPercent } from '@/lib/formatter'
import { cn } from '@/lib/utils'
import { Ranking } from '@/redux/ranking'

export interface TopRankingProps {
  ranking: Ranking | undefined
  index: 1 | 2 | 3
}

export default function TopRanking({
  ranking,
  index,
}: TopRankingProps) {
  const {
    user,
    roi,
  } = ranking || {}
  return (
    <Link
      href={`/src/app/(main)/account/${user?.id}`}
      className={cn(
        'w-[20.625rem] relative text-center bg-contain bg-no-repeat pt-10 backdrop-blur-[20px]',
        index === 1 && 'h-[21rem] bg-[url("/home-images/first-background.png")]',
        index === 2 && 'h-[19.5rem] bg-[url("/home-images/second-background.png")]',
        index === 3 && 'h-[19.5rem] bg-[url("/home-images/third-background.png")]',
      )}
    >
      <div className="flex items-center justify-center gap-4">
        <div className="relative bottom-2 [&>img]:relative [&>img]:z-1">
          {index === 1 && <Image src="/home-images/first-badge.png" width={64} height={74} alt="first badge" />}
          {index === 2 && <Image src="/home-images/second-badge.png" width={64} height={74} alt="second badge" />}
          {index === 3 && <Image src="/home-images/third-badge.png" width={64} height={74} alt="third badge" />}
          <Avatar
            className="absolute bottom-0 right-0 size-[59px]"
            src={user?.avatar}
          />
        </div>
        <Nickname className="font-bold text-shadow-[0_2px_8px_rgba(0,0,0,0.15)] text-2xl font-urbanist" user={user} />
      </div>
      <div
        className={clsx(
          'text-3xl font-semibold font-poly-sans mt-2 bg-clip-text text-transparent',
          index === 1 && 'bg-[linear-gradient(143deg,#FFF_18.22%,#EDC46D_51.45%,#F2D391_81.35%)]',
          index === 2 && 'bg-[linear-gradient(143deg,#FFF_18.22%,#7592B4_51.45%,#97B3D5_81.35%)]',
          index === 3 && 'bg-[linear-gradient(143deg,#FFF_18.22%,#BF8761_51.45%,#DAAC89_81.35%)]',
        )}
      >
        <span className="text-[5rem]">{index}</span>
        {index === 1 && 'st'}
        {index === 2 && 'nd'}
        {index === 3 && 'rd'}
      </div>
      <div className="rounded-full bg-linear-to-b from-white/10 to-white/4 px-4 py-2 inline-flex gap-2 items-center mt-2">
        <div className="text-tertiary-foreground text-xl">ROI</div>
        <div className="text-2xl font-semibold">{formatPercent()(roi)}</div>
      </div>
    </Link>
  )
}
